import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/Link';
import { SvgPlayFilled } from '../../../icons';
import { RerunProgram } from '../../../queries/ats/titles/types/sources';
import { routes } from '../../../routes/route-utils';
import styles from './details-button.module.scss';

interface WatchFromArchiveProps {
  rerun: RerunProgram;
}

export const WatchFromArchive = forwardRef<HTMLAnchorElement, WatchFromArchiveProps>(({ rerun }, ref) => {
  const { t } = useTranslation();

  return (
    <Link
      ref={ref}
      to={routes.play({ platformTitleId: rerun.platformTitleId, providerIdentifier: rerun.providerIdentifier })}
      className={styles.secondary}
    >
      <SvgPlayFilled /> {t('details:watch-from-archive')}
    </Link>
  );
});
